import { useRef, useState } from 'react'

const useTimeline = () => {
  const [isExpanded, setIsExpanded] = useState(false)
  const contentRef = useRef(null)

  const handleToggle = () => {
    setIsExpanded(prev => !prev)
  }

  return { isExpanded, handleToggle, contentRef }
}

export default useTimeline
